
import { ActionTypes, UIState } from "@/modules/ui/store/types";
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";
import IconButton from "./IconButton.vue";
import VIcon from "./VIcon.vue";

export default defineComponent({
  components: { IconButton, VIcon },
  name: "TheNavigation",
  data() {
    return {
      mobileView: false,
    };
  },
  methods: {
    ...mapActions("ui", [ActionTypes.TOGGLE_NAV]),
    handleView() {
      this.mobileView = window.innerWidth <= 768;
    },
  },
  computed: {
    ...mapState("ui", {
      isNavOpen: (state) => (state as UIState).isNavOpen,
    }),
  },
  watch: {
    mobileView(value) {
      value ? null : this.toggleNav(false);
    },
  },
  created() {
    window.addEventListener("resize", this.handleView);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleView);
  },
});
